import Vue from 'vue';
import Router from 'vue-router';
import LoginView from './views/common/LoginView.vue';
import { UserType } from './services/LoginService';
import { app } from "./models/Application";

// Shell
import SuperAdminShell from './views/superadmin/SuperAdminShell.vue'
import AdminShell from './views/admin/AdminShell.vue'
import WaiterShell from './views/waiter/WaiterShell.vue'
import CookShell from './views/cook/CookShell.vue'
import BartenderShell from './views/bartender/BartenderShell.vue'
import DriverShell from './views/driver/DriverShell.vue'

// SuperAdmin
import SuperAdminHomeView from './views/superadmin/SuperAdminHomeView.vue'
import FoodCategoriesView from './views/superadmin/FoodCategoriesView.vue'
import RestaurantsView from './views/superadmin/RestaurantsView.vue'
import RestaurantsSalesReportView from './views/superadmin/RestaurantsSalesReportView.vue'

// Admin
import AdminHomeView from './views/admin/AdminHomeView.vue'
import ProductsView from './views/admin/ProductsView.vue'
import OrdersView from './views/common/OrdersView.vue';
import StaffView from './views/admin/StaffView.vue';
import TablesView from './views/admin/TablesView.vue';
import FloorLayoutView from './views/admin/FloorLayoutView.vue';
import TableAssigmentsView from './views/admin/TableAssigmentsView.vue'
import SalesPerDayReportView from './views/admin/SalesPerDayReportView.vue'
import SalesPerProductReportView from './views/admin/SalesPerProductReportView.vue'
import PromotionsView from './views/admin/PromotionsView.vue'
import RestaurantProfileView from './views/admin/RestaurantProfileView.vue'
import TipsView from './views/admin/TipsView.vue'


//Waiter
import WaiterHomeView from './views/waiter/WaiterHomeView.vue'

//Cook
import CookHomeView from './views/cook/CookHomeView.vue'

//Bartender
import BartenderHomeView from './views/bartender/BartenderHomeView.vue'

//Driver
import DriverHomeView from './views/driver/DriverHomeView.vue'


//Common for Staff and Admin
import ProfileView from './views/common/ProfileView.vue'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: LoginView,
        },
        {
            path: '/superadmin',
            name: 'superadmin',
            component: SuperAdminShell,
            children: [
                {
                    path: 'home',
                    name: 'superadmin_home',
                    component: SuperAdminHomeView
                },
                {
                    path: "categories",
                    name: 'categories',
                    component: FoodCategoriesView
                },
                {
                    path: "restaurants",
                    name: 'restaurants',
                    component: RestaurantsView
                },
                {
                    path: "profile",
                    name: 'superadmin_profile',
                    component: ProfileView
                },
                {
                    path: 'reports/restaurants-sales-report',
                    name: 'restaurants-sales-report',
                    component: RestaurantsSalesReportView,
                }
            ]
        },
        {
            path: '/admin',
            name: 'admin',
            component: AdminShell,
            children: [
                {
                    path: 'home',
                    name: 'admin_home',
                    component: AdminHomeView
                },
                {
                    path: 'products',
                    name: 'products',
                    component: ProductsView
                },
                {
                    path: 'floorlayouts',
                    name: 'floorlayouts',
                    component: FloorLayoutView
                },
                {
                    path: 'tables',
                    name: 'tables',
                    component: TablesView
                },
                {
                    path: 'staff',
                    name: 'admin_staff',
                    component: StaffView
                },
                {
                    path: 'orders',
                    name: 'orders',
                    component: OrdersView
                },
                {
                    path: "table-assigments",
                    name: 'table_assigments',
                    component: TableAssigmentsView
                },
                {
                    path: 'reports/sales-per-product-report',
                    name: 'sales-per-product-report',
                    component: SalesPerProductReportView,
                },
                {
                    path: 'reports/sales-per-day-report',
                    name: 'sales-per-day-report',
                    component: SalesPerDayReportView,
                },
                {
                    path: 'promotions',
                    name: 'promotions',
                    component: PromotionsView,
                },
                {
                    path: 'tips',
                    name: 'tips',
                    component: TipsView,
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: ProfileView,
                },
                {
                    path: 'restaurant-profile',
                    name: 'restaurant_profile',
                    component: RestaurantProfileView,
                }
            ]
        },
        {
            path: '/waiter',
            name: 'waiter',
            component: WaiterShell,
            children: [
                {
                    path: 'home',
                    name: 'waiter_home',
                    component: WaiterHomeView
                },
                {
                    path: 'profile',
                    name: 'waiter_profile',
                    component: ProfileView,
                },
                {
                    path: 'orders',
                    name: 'waiter_orders',
                    component: OrdersView
                }
            ]
        },
        {
            path: '/cook',
            name: 'cook',
            component: CookShell,
            children: [
                {
                    path: 'home',
                    name: 'cook_home',
                    component: CookHomeView
                },
                {
                    path: 'profile',
                    name: 'cook_profile',
                    component: ProfileView,
                }
            ]
        },
        {
            path: '/bartender',
            name: 'bartender',
            component: BartenderShell,
            children: [
                {
                    path: 'home',
                    name: 'bartender_home',
                    component: BartenderHomeView
                },
                {
                    path: 'profile',
                    name: 'bartender_profile',
                    component: ProfileView,
                }
            ]
        },
        {
            path: '/driver',
            name: 'driver',
            component: DriverShell,
            children: [
                {
                    path: 'home',
                    name: 'driver_home',
                    component: DriverHomeView
                },
                {
                    path: 'profile',
                    name: 'driver_profile',
                    component: ProfileView,
                }
            ]
        },
    ],
});

router.beforeEach((to, from, next) => {
    const user = app.loginService.currentUser();
    if (to.name === "login") {
        next();
    } else if (user) {
        if (user && user.user_type && to.path) {
            if ((user.user_type === UserType.SuperAdministrator && to.path.indexOf("superadmin") !== -1)
                || (user.user_type === UserType.Administrator && to.path.indexOf("admin") !== -1)
                || (user.user_type === UserType.Waiter && to.path.indexOf("waiter") !== -1)
                || (user.user_type === UserType.Cook && to.path.indexOf("cook") !== -1)
                || user.user_type === UserType.Bartender && to.path.indexOf("bartender") !== -1
                || (user.user_type === UserType.Driver && to.path.indexOf("driver") !== -1)) {
                next();
            } else {
                (window as any).returnRoute = next;
                next({ name: "login" });
            }
        } else {
            (window as any).returnRoute = next;
            next({ name: "login" });
        }

    } else {
        (window as any).returnRoute = next;
        next({ name: "login" });
    }


});

export default router;